import * as React from 'react';
import { SHIPMENT_TYPE } from './ContainerUtils';
import { Transition, TransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';

const ContainerDetailsTrackingList = (props) => {

  const {
    getFilteredContainers,
    selectedSubContainer,
    container,
    classes,
    noTrackingFound,
    shipmentType,
    renderTrackingView,
    duration,
    isHBL,
    containerDetails,
  } = props;

  const filteredContainers = getFilteredContainers();
  return (
    <React.Fragment>
      {filteredContainers?.length && (selectedSubContainer || container).containerNumber ? <div className={classes.containerStep}>
        {selectedSubContainer?.tracking && selectedSubContainer?.isTrackingPresent ?
          <TransitionGroup>
            <Transition
              key={(selectedSubContainer || container).containerNumber}
              timeout={duration}>
              {state => renderTrackingView(selectedSubContainer, state)}
            </Transition>
          </TransitionGroup>
        : noTrackingFound()}
      </div> : ''}
      {isHBL() && !(container?.isInfoPresent || !container?.isInfoFetchFailed) && noTrackingFound()}
      {shipmentType !== SHIPMENT_TYPE.CN &&
        container?.tracking &&
        containerDetails.length === 0 &&
        <div className={classes.containerStep}>
          <TransitionGroup>
            <Transition timeout={duration}>
              {state => renderTrackingView(container, state)}
            </Transition>
          </TransitionGroup></div>}
    </React.Fragment>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default connect(mapStateToProps)(ContainerDetailsTrackingList);
